import { IEltDocCompany } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltDocCompany'
import { IEltDocFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { TUpdateELTFormData } from 'legacy/lut/components/widgets/public/partner360/ELT/models/common'
import { TMergedImages } from 'legacy/lut/components/widgets/public/partner360/ELT/models/ImageUpload'
import { CompanyImageUploader } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/companyImageUploader/CompanyImageUploader'
import { RoundTableSection } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/roundTable/components/roundTableSection/RoundTableSection'
import { useCallback } from 'react'

import { Input } from 'core-components/library/inputs'
import { MultiInputsControl } from 'partner360/components/multiInputsControl'

import styles from './Company.module.scss'

interface ICompanyProps {
  formData: IEltDocFormData
  onChangeComplexFormData: (data: IEltDocCompany) => void
  onImageUpload: (fieldName: string, file: any, fileName: string) => void
  updateData: TUpdateELTFormData
  formIsFinalized: boolean
  displayedImages: TMergedImages
}

export const Company = ({
  formData,
  onChangeComplexFormData,
  onImageUpload,
  updateData,
  formIsFinalized,
  displayedImages,
}: ICompanyProps) => {
  const changeCompanyName = useCallback(
    (value: string) => {
      onChangeComplexFormData({ ...formData.Company, Name: value })
    },
    [formData.Company, onChangeComplexFormData]
  )

  const changeCompanyInfo = useCallback(
    (value: string[]) => {
      onChangeComplexFormData({ ...formData.Company, CompanyInfo: value })
    },
    [formData.Company, onChangeComplexFormData]
  )

  return (
    <div className={styles.root}>
      <CompanyImageUploader
        onImageUpload={onImageUpload}
        updateData={updateData}
        formIsFinalized={formIsFinalized}
        titleVariant={'dark'}
        displayedImages={displayedImages}
      />
      <Input
        classes={{
          root: styles.input,
        }}
        value={formData.Company?.Name || ''}
        onChange={changeCompanyName}
      />
      <RoundTableSection showLabel>
        <MultiInputsControl
          values={formData.Company?.CompanyInfo || []}
          withDot
          onChange={changeCompanyInfo}
          placeholder={getFormedEltTranslation('enter-value')}
        />
      </RoundTableSection>
    </div>
  )
}
